/*
1) get all projects in-progress.
*/

import { Location, ViewportScroller } from "@angular/common";
import {
    OnInit,
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { WorkRequestService } from "@app-services/work-request.service";
import {
    WorkRequest,
    IWorkRequestQueryOptions,
} from "@app-models/work-request";
import { DatePipe } from "@angular/common";
import {
    getCurrentUserFromStorage,
    setPreviousViewInStorage,
    setScreenModeInStorage,

} from "@app/utils/storage-utils";
import { AzureUser } from "@app-models/azure-user";
import { AlertService } from "@app/modules/alert";
import { GlobalConstants } from "@app/utils/global-constants";
import { GlobalService } from "@app-services/global.services";

import { NgxSpinnerService } from "ngx-spinner";



@Component({
    selector: "app-non-project-dashboard",
    templateUrl: "./non-project-dashboard.component.html",
    styleUrls: ["./non-project-dashboard.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default
})
export class NonProjectDashboardComponent implements OnInit {


    //------------------------------------------
    // Constants
    //------------------------------------------
    infoMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: false,
    };
    errorMesageOptions = {
        autoClose: false,
        keepAfterRouteChange: true,
    };

    saveMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: true,
    };

    errorMessage = "message";

    DATE_FORMAT = "yyyy-MM-dd";
    DATE_TIME_FORMAT = "yyyy-MM-dd h:mm:ss a";


    //------------------------------------------
    //
    //------------------------------------------

    workRequest: WorkRequest = { projectStatus: "" }
    projectItLead= "";
    projectHeader= "Enterprise Technology Consultation/Work Order Dashboard";
    consultationWorkRequests: WorkRequest[];
    WorkOrders: WorkRequest[];
    formError = "";
    systemDate: Date = new Date();
    currentUser: AzureUser;

    REQUEST_TYPE_CONSULTATION_VALUE = GlobalConstants.REQUEST_TYPE_CONSULTATION_VALUE;
    REQUEST_TYPE_WORK_ORDER_VALUE = GlobalConstants.REQUEST_TYPE_WORK_ORDER_VALUE;
    

    nonProjectCheckpoints = GlobalConstants.nonProjectCheckpoints;

    constructor(
        public datePipe: DatePipe,
        private changeDetectorRef: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private workRequestService: WorkRequestService,
        private location: Location,
        private globalService: GlobalService,
        private viewportScroller: ViewportScroller,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,

    ) {

    }

    //--------------------------
    // Life Cycle Events
    //--------------------------
    ngOnInit(): void {
        this.systemDate = this.globalService.getSystemDate();
        this.getProjectWorkRequests();

        this.currentUser = getCurrentUserFromStorage();
        this.viewportScroller.scrollToPosition([0, 0]);
    }


    decodeStatus(input: string, shortInd: boolean): string {
        let ret = input;
        for (const s of this.nonProjectCheckpoints) {
            if (s.key == input) {
                ret = shortInd ? s.short : s.value;
                break;
            }
        }
        return ret;
    }

    getProjectWorkRequests() {
        this.spinner.show();
        const pagingOpts = { pageNumber: 1, pageSize: 500, nextUrl: "" };
        const opts: IWorkRequestQueryOptions = {};

        //let formFilter = this.formFilters.get(this.FILTER_VENDOR);
        opts.status = [GlobalConstants.STATUS_IN_PROGRESS];
        opts.requestType = [GlobalConstants.REQUEST_TYPE_CONSULTATION, GlobalConstants.REQUEST_TYPE_WORK_ORDER];

        this.consultationWorkRequests = [];
        this.WorkOrders = [];

        this.workRequestService
            .getWorkRequestList("", pagingOpts, opts)
            .subscribe({
                next: (response) => {

                    if (response === null) {
                        this.alertService.error(
                            "A problem occuring reading work requests", this.errorMesageOptions
                        );
                        this.router.navigate(["/home"]);
                        this.spinner.hide();
                    }

                    //this.projectWorkRequests = response.data;
                    for (const rec of response.data) {
                        rec.projectItLead = "";
                        rec.projectManager = "";
                        rec.keyUpdates = "";
                        for (const pr of rec.requestResources) {
                            if (pr.role === GlobalConstants.PROJECT_IT_LEAD_ROLE) {
                                rec.projectItLead = rec.projectItLead + pr.name + "<br/>";
                            }
                            if (pr.role === GlobalConstants.PROJECT_MANAGER_ROLE) {
                                rec.projectManager = rec.projectManager + pr.name + "<br/>";
                            }

                        }
                        if (rec.projectItLead.length > 1) {
                            rec.projectItLead = rec.projectItLead.slice(0, -5);
                        }
                        if (rec.projectManager.length > 1) {
                            rec.projectManager = rec.projectManager.slice(0, -5);
                        }

                        for (const pmm of rec.pmMilestones) {
                            if (pmm.showInReporting) {
                                rec.keyUpdates = rec.keyUpdates + pmm.description + "<br/>";
                            }
                        }
                        if (rec.keyUpdates.length > 1) {
                            rec.keyUpdates = rec.keyUpdates.slice(0, -5);
                        }

                        if (rec.requestType === GlobalConstants.REQUEST_TYPE_WORK_ORDER) {
                            this.WorkOrders.push(rec);
                        } else if (rec.requestType === GlobalConstants.REQUEST_TYPE_CONSULTATION) {
                            this.consultationWorkRequests.push(rec);
                        }

                    }

                    this.spinner.hide();
                },
                error: () => {
                    this.spinner.hide();
                }
            });
    }


    goto(rec: WorkRequest) {
        setPreviousViewInStorage(this.router.url);
        setScreenModeInStorage(GlobalConstants.REQUEST_FORM_MODE_READ_ONLY);
        const route = "/work-request/" + rec.workRequestId;
        this.router.navigateByUrl(route, {});
    }

    scrollTo(target: string) {
        //this.scroller.scrollToAnchor("targetGreen");
        document.getElementById(target)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }


}
